import { apiEditor } from 'services/api/api';
import { EditorApiEndpoints } from 'utils/endpoints/endpoints';
import { appendQueryParams } from 'utils/requestUtils';
import { DadosCamposPorRegistro } from 'utils/types/blocoRegistros';

export const getCamposPorRegistro = async (
  codigo: string,
  paiLoaderId: number,
  pagina: number,
  quantidadeNaPagina: number,
  processamentoSpedId?: string,
  filtroLinha?: number,
  modificadoresCategoriaBlocoIds?: number[],
  modificadoresCategoriaRegistroIds?: number[],
): Promise<DadosCamposPorRegistro> => {
  const queryParams = {
    filtroLinha,
    paiLoaderId: paiLoaderId || null,
    pagina,
    quantidadeNaPagina,
    modificadoresCategoriaBlocoIds,
    modificadoresCategoriaRegistroIds,
  };

  const url = appendQueryParams(
    `${EditorApiEndpoints.GetCamposPorRegistro}${codigo}/campos`,
    queryParams,
  );

  const response = await apiEditor.get<DadosCamposPorRegistro>(url, {
    headers: {
      'Processamento-Sped-ID': processamentoSpedId,
    },
  });

  return response.data;
};
